import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { ErrorMessages } from "./ErrorMessages";

/**
 * Implements common behaviour for all login forms.
 * (LoginForm, SmsForm, EmailForm, TotpForm)
 */
export abstract class FormBase {
    protected _errorMessages = new ErrorMessages();

    //#region Methods
    protected abstract _getErrorElement(): HTMLElement;
    protected abstract _getSubmitLoginElement(): HTMLInputElement;
    protected _successful: boolean = false;

    protected _clearError(): void {
        const errorElement = this._getErrorElement();
        errorElement.innerHTML = "";
    }

    protected _displayError(error: any): void {
        this._displayFromErrorCodeOrDefault(error.code, error.toString());
    }

    protected _displayErrorFromCode(errorCode: string): void {
        this._displayFromErrorCodeOrDefault(errorCode, errorCode);
    }

    protected _registerAsyncClickEventListenerToElementById(elementId: string, eventListenerCallback: (e: Event) => Promise<any>): void {
        const element = document.getElementById(elementId) as HTMLInputElement;
        this._registerAsyncClickEventListener(element, eventListenerCallback);
    }

    protected _registerAsyncClickEventListener(element: HTMLInputElement, eventListenerCallback: (e: Event) => Promise<any>): void {
        element.addEventListener("click", (e) => {
            element.disabled = true;
            eventListenerCallback(e).finally(
                () => element.disabled = this._successful,
            );
        });
    }

    protected _registerClickEventListenerToElementById(elementId: string, eventListenerCallback: (e: Event) => any): void {
        const element = document.getElementById(elementId) as HTMLInputElement;
        this._registerClickEventListener(element, eventListenerCallback);
    }

    protected _registerClickEventListener(element: HTMLInputElement, eventListenerCallback: (e: Event) => any): void {
        element.addEventListener("click", (e) => {
            eventListenerCallback(e);
        });
    }

    /**
     * Tries to find localization for the given errorCode and displays the correct message.
     * If the errorCode is not recognized, displays defaultMessage instead.
     */
    private _displayFromErrorCodeOrDefault(errorCode: string, defaultMessage: string): void {
        const errorElement = this._getErrorElement();

        if (this._errorMessages.errorCodeLocalizationMap.has(errorCode)) {
            Localization.addLocData(errorElement, this._errorMessages.errorCodeLocalizationMap.get(errorCode));
        } else {
            errorElement.innerHTML = defaultMessage;
        }
    }
    //#endregion Methods
}
